import { compute_results_cards, default_course_form, default_result_form, normalise_course_drawer, normalise_training_copy, result_form_from_row, status_meta_map } from './training_program_helpers';
import { build_course_drawer_payload, create_course_state, create_result_state } from './training_program_ui_helpers';

export const training_program_methods = {
  set_tab(tab_id) { this.active_tab = tab_id; },
  open_course_modal() { this.show_course_modal = true; },
  close_course_modal() { this.show_course_modal = false; this.course_form = default_course_form(); },
  open_result_modal() { this.result_modal_mode = 'create'; this.editing_result_index = null; this.result_form = default_result_form(); this.show_result_modal = true; },
  close_result_modal() { this.show_result_modal = false; this.result_modal_mode = 'create'; this.editing_result_index = null; this.result_form = default_result_form(); },
  open_result_editor(row, index) { this.result_modal_mode = 'edit'; this.editing_result_index = index; this.result_form = result_form_from_row(row); this.show_result_modal = true; },
  open_course_drawer(course_name) {
    const normalised_name = normalise_training_copy(course_name);
    const existing_drawer =
      Reflect.get(this.course_drawers, normalised_name) ||
      Reflect.get(this.course_drawers, course_name);

    if (existing_drawer) {
      this.active_course_drawer = normalise_course_drawer(existing_drawer);
      return;
    }

    const row = this.matrix_rows.find((item) => item.course === course_name);
    if (!row) return;
    this.active_course_drawer = normalise_course_drawer(this.build_course_drawer_from_row(row));
  },
  close_course_drawer() { this.active_course_drawer = null; },
  get_status_meta(label) {
    const status_meta =
      Reflect.get(status_meta_map, label) ||
      Reflect.get(status_meta_map, 'On track');
    return status_meta;
  },
  build_course_drawer_from_row(row, form_override = null) {
    const training_drawer = build_course_drawer_payload(this, row, form_override);
    return training_drawer;
  },
  create_course() {
    const course_state = create_course_state({
      course_form: this.course_form,
      matrix_rows: this.matrix_rows,
      status_meta_map
    });
    if (!course_state) return;

    this.matrix_rows.unshift(course_state.row);
    this.matrix_cards[0].value = String(this.matrix_rows.length);
    this.course_drawers = { [course_state.course_name]: course_state.drawer, ...this.course_drawers };
    this.close_course_modal();
    this.active_course_drawer = course_state.drawer;
  },
  create_result_record() {
    const result_row = create_result_state(this.result_form);
    if (!result_row) return;
    this.results_rows.unshift(result_row);
    this.results_cards = compute_results_cards(this.results_rows);
    const tab = this.tabs.find((item) => item.id === 'results');
    if (tab) tab.count = this.results_rows.length;
    this.close_result_modal();
  },
  save_result_record() {
    if (this.result_modal_mode !== 'edit' || this.editing_result_index === null) return this.create_result_record();
    const result_row = create_result_state(this.result_form);
    if (!result_row) return;
    this.results_rows.splice(this.editing_result_index, 1, result_row);
    this.results_cards = compute_results_cards(this.results_rows);
    this.close_result_modal();
  },
  delete_result_record() {
    if (this.result_modal_mode !== 'edit' || this.editing_result_index === null) return;
    this.results_rows.splice(this.editing_result_index, 1);
    this.results_cards = compute_results_cards(this.results_rows);
    const tab = this.tabs.find((item) => item.id === 'results');
    if (tab) tab.count = this.results_rows.length;
    this.close_result_modal();
  },
  open_refresher_destination(row) {
    const target = this.refresher_department_routes[row.department];
    if (target) this.$router.push(target);
  }
};
